import { render, staticRenderFns } from "./AssignStudent.vue?vue&type=template&id=991fbb38&scoped=true"
import script from "./AssignStudent.vue?vue&type=script&lang=js"
export * from "./AssignStudent.vue?vue&type=script&lang=js"
import style0 from "./AssignStudent.vue?vue&type=style&index=0&id=991fbb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991fbb38",
  null
  
)

export default component.exports